import React from "react";
import clsx from "clsx";
import SettingsIcon from "@material-ui/icons/Settings";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Popover from "@material-ui/core/Popover";
import useStyles from "./styles";

interface IProps {
  children: React.ReactNode;
}

const SettingsPopover = (props: IProps) => {
  const { children } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(e.currentTarget);

  const handleClose = () => setAnchorEl(null);

  return (
    <section className={classes.root}>
      <Button
        variant="text"
        color="default"
        classes={{
          root: classes.buttonRoot,
          startIcon: clsx(classes.icon, {
            [classes.iconActive]: open
          })
        }}
        className={clsx(classes.button, {
          [classes.buttonActive]: open
        })}
        startIcon={<SettingsIcon />}
        onClick={handleOpen}
      >
        <span className={classes.buttonText}>Settings</span>
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        classes={{
          paper: classes.paper
        }}
        elevation={24}
      >
        <Container className={classes.rootPopover}>{children}</Container>
      </Popover>
    </section>
  );
};

export default SettingsPopover;
